<template>
    <div class="mainBox">
        <div class="main-header">
			<el-row :gutter="10">
				<el-col :span="6">
					<el-button icon='el-icon-refresh' size="medium" @click='init'>刷新</el-button>
				</el-col>
				<el-col :span="18">
					<el-form ref="search_form" :model="searchForm" class='search_form'>
						<el-row :gutter="10">
							<el-col :span="5" :offset="16">
                                <el-form-item prop="telephone">
                                    <el-input v-model="searchForm.telephone" size="medium" placeholder="请输入手机号" clearable></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="3">
                                <el-button type="primary" class="searchBtn" size="medium" icon='el-icon-search' @click='searchFormDatas'>查询</el-button>
                            </el-col>
						</el-row>
					</el-form>
				</el-col>
			</el-row>
		</div>
        <div class="main-content">
            <el-table :data="mainLists" border>
                <el-table-column
                    type="index"
                    align="center"
                    width="50">
                </el-table-column>
                <el-table-column
                    prop="name"
                    align="center"
                    label="姓名">
                </el-table-column>
                <el-table-column
                    prop="telephone"
                    align="center"
                    label="电话">
                </el-table-column>
                <el-table-column
                    prop="email"
                    align="center"
                    label="email">
                </el-table-column>
                <el-table-column
                    prop="content"
                    align="center"
                    label="内容">
                </el-table-column>
                <el-table-column
                    prop="created_at"
                    label="创建时间"
                    align="center"
                    min-width="140px">
                </el-table-column>
                <el-table-column
                    label="操作"
                    width="220"
                    align="center">
                    <template slot-scope="scope">
                        <el-button
                            type="danger"
                            size="mini"
                            icon="el-icon-delete"
                            @click="handleDel(scope.row,scope.$index)">
                            删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!--分页-->
        <div class="pagination-footer" v-show="pagination.totalNum > 0">
            <el-pagination
                background
                layout="prev, pager, next"
                :current-page="pagination.page"
                :page-size="pagination.pageSize"
                :total="pagination.totalNum"
                @current-change="pageChangeHandle">
            </el-pagination>
        </div>
    </div>
</template>

<script>
    import {messageList,messageDel} from '@/utils/getData';
    export default {
        name: "messageList",
        data(){
            return{
                searchForm:{
                    telephone:"",
                },
                mainLists:[],//列表
                pagination: {
                    page: 1, //当前页数
                    pageSize: 20, //每页显示的条数
                    totalNum: 100 //总条数
                }
            }
        },
        mounted(){
            this.init();
        },
        methods:{
            async init(){
                messageList(this.pagination.page, this.searchForm).then(res => {
					if (res.code == 0) {
						this.pagination.pageSize = res.data.pageSize;
						this.pagination.totalNum = res.data.count;
						this.mainLists = res.data.rows;
					} else {
						this.$message({
							showClose: true,
							message: res.message,
							type: 'error'
						});
					}
                })
            },
            pageChangeHandle(val){
                this.pagination.page = val;
				this.init();
            },
            searchFormDatas() { //表单搜索
				this.init();
			},
            handleDel(currentRow,index){//删除
                this.$confirm('确定要删除吗', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async () => {
                    const res = await messageDel(currentRow.id);
                    if (res.code == 0) {
                        this.mainLists.splice(index,1);
                        this.$message({
                            showClose: true,
                            message: res.message,
                            type: 'success'
                        });
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.message,
                            type: 'error'
                        });
                    }
                }).catch((e) => {
                    if(e == 'cancel'){
                        return false;
                    }
                    this.$message({
                        showClose:true,
                        message: e.message,
                        type: 'error'
                    });
                });
            }
        }
    }
</script>

<style scoped>
</style>